// Auth utilities matching server implementation
// Access token: 15min (memory only)
// Refresh token: 7 days (httpOnly cookie, handled by browser)

const ACCESS_TOKEN_KEY = 'hedgi_access_token'

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export function clearAccessToken(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function clearAuth(): void {
  clearAccessToken()
  // Refresh token is cleared by server via Set-Cookie or will expire naturally
}

export function isAuthenticated(): boolean {
  return !!getAccessToken()
}

// Parse JWT to check expiration (basic, no verification)
export function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp * 1000 < Date.now()
  } catch {
    return true
  }
}
